<div class="modal-header" id="loading-screen-modal-title">
    <h3 class="modal-title" id="modal-title" translate="LOADING_SCREEN_TITLE"></h3>
</div>
<div class="modal-body" id="modal-body">
    <div>
        <fieldset>
            <div class="row mb-3">
                <div class="col-sm-12">{{ model.message }}</div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <progressbar *ngIf="model.usePercent" [value]="model.percent">{{ model.percent }}% </progressbar>
                    <progressbar type="default" *ngIf="!model.usePercent" [value]="100" [animate]="true"> </progressbar>
                </div>
            </div>
        </fieldset>
    </div>
</div>
